/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {getOrientation} from '@gongxigames/framework/slotV2/modules/loadingScreenV2/utils/getOrientation';
import {LSViewConfig} from '@gongxigames/framework/slotV2/modules/loadingScreenV2/loadingScreenViewConfig';
import {CanBeSignal} from "@gongxigames/framework/core/fragments/BuilderY";
import {ComputedSignal} from '@gongxigames/framework/core';
import {Graphics, Point} from 'pixi.js';
import {
    $Container, $GraphicsBox, $Sprite, ExtendContainerProps,
    FC, getProp
} from '@gongxigames/framework/core/fragments/BuilderY';
import {Store} from '@gongxigames/framework/core';

type ProgressIndicatorProps = ExtendContainerProps<{
    progress: number;
    position: Point;
    scale?: number;
    frame: string;
    full: string;
    empty: string;
}>;

export const $ProgressIndicator: FC<ProgressIndicatorProps> = (props) => {
    const progressSize = Store.signal({width: 0, height: 0});
    const fullSize = Store.signal({width: 0, height: 0});

    const horizontalPadding = Store.computed(() => {
        return (fullSize.value.width - progressSize.value.width) / 2;
    });

    const boxWidth = Store.computed(() => {
        const progress = getProp(props.progress);
        if (progress === 1) return progressSize.value.width;
        return progress * progressSize.value.width + horizontalPadding.value;
    });

    const mask = Store.computed(() => {
        return <$GraphicsBox
            boxWidth={boxWidth}
            boxHeight={progressSize.value.height}
            y={-progressSize.value.height / 2}
            x={-progressSize.value.width / 2}
            boxColor={0XFFFFFF}
        /> as Graphics;
    });

    return (
        <$Container {...props} name='ProgressIndicator'>
            <$Sprite
                ref={(ref) => {
                    if (ref) {
                        progressSize.value.width = ref.width;
                        progressSize.value.height = ref.height;
                    }
                }}
                texture={props.empty} anchor={0.5} />
            <$Sprite
                ref={(ref) => {
                    if (ref) {
                        fullSize.value.width = ref.width;
                        fullSize.value.height = ref.height;
                    }
                }}
                texture={props.full} anchor={0.5} mask={mask.value}
            />
            <$Sprite texture={props.frame} anchor={0.5} />
            {mask.value}
        </$Container>
    );
};

export const renderProgress = (progress: CanBeSignal<number>) => (
    <$ProgressIndicator
        position={getOrientation(LSViewConfig.progressBar.position)}
        progress={progress}
        visible={Store.computed(() => getProp(progress) < 1)}
        scale={getOrientation(LSViewConfig.progressBar.scale)}

        frame={LSViewConfig.progressBar.frame}
        full={LSViewConfig.progressBar.full}
        empty={LSViewConfig.progressBar.empty}
    />
);